import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { wishItemRequestSchema } from "validations/wishItem"
import { AppDispatch } from "appRedux/store"
import { useAppSelector } from "appRedux/hooks"
import { useEditWishItemMutation } from "appRedux/slices/wishItemApiSlice"
import { updateItemFormFields } from "appRedux/slices/itemFormSlice"
import useWishItem from "hooks/useWishItem"
import { useAuth } from "context/AuthContext"
import WishItemForm from "components/templates/WishItemForm"

export default function EditItemPage() {
  const currentPageInfo = useAppSelector((state) => state.global.currentPageInfo)
  const wishListState = useAppSelector((state) => state.wishList)

  const [editWishItem, editWishItemResult] = useEditWishItemMutation()

  useWishItem()

  const { user } = useAuth()
  const navigate = useNavigate()
  const dispatch = useDispatch() as AppDispatch

  useEffect(() => {
    if (!wishListState.itemInfo) return
    if (!wishListState.itemInfo.hasOwnProperty("wishlists")) return
    const itemInfo = wishListState.itemInfo
    dispatch(updateItemFormFields({
      name: itemInfo.name,
      caption: itemInfo.caption,
      url: itemInfo.url,
      image: itemInfo.image || "",
      wishlistIds: itemInfo.wishlists?.map(list => list.id) || [],
      price: itemInfo.price,
      currency: itemInfo.currency
    }))
  }, [wishListState.itemInfo])

  useEffect(() => {
    if (editWishItemResult.status !== "fulfilled") return
    if (!wishListState?.itemInfo) return
    handleWishItemEditedSuccessfully(wishListState?.itemInfo)
  }, [editWishItemResult.status])

  function handleWishItemEditedSuccessfully(item: SingleWishItem) {
    const listId = wishListState?.listInfo?.id
    const handle = user?.handle
    if (listId !== -1) {
      navigate(`/user/${handle}/list/${listId}`, { replace: true })
    } else {
      navigate(`/user/${handle}/items`, { replace: true })
    }
  }

  function isCTADisabled(dirtyFields: object) {
    return Object.keys(dirtyFields).length === 0 || editWishItemResult.isLoading
  }

  async function handleEditWishItem(value: WishItemRequestPayload) {
    if (!currentPageInfo?.dynamicPathParts) return
    const formData = new FormData()
    try {
      const parsedValue = await wishItemRequestSchema.parseAsync(value)
      Object.entries(parsedValue).forEach(([key, val]) => {
        if (key === "image" && typeof val === "string") return
        formData.append(key, val)
      })
      editWishItem({
        id: currentPageInfo?.dynamicPathParts?.itemId,
        body: formData
      })
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <WishItemForm
      isCTADisabled={isCTADisabled}
      isCTALoading={() => editWishItemResult.isLoading}
      onSubmit={handleEditWishItem}
    />
  )
}
